import type { AssetLabel } from '@/pages/dam/api';

/** Tag names are compared trimmed and case-insensitively; the server does not check uniqueness yet (LAX-10488). */
const normalizeTagName = (name: string) => name.trim().toLocaleLowerCase();

const sortLabelsAlphabetically = <T extends Pick<AssetLabel, 'name'>>(labels: T[]) =>
    [...labels].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));

/** The label carrying `name` (case-insensitive), ignoring `exceptId`, e.g. the label being renamed. */
const findLabelByName = (labels: AssetLabel[], name: string, exceptId?: string) => {
    const normalized = normalizeTagName(name);
    return labels.find((label) => label.id !== exceptId && normalizeTagName(label.name) === normalized);
};

/** Labels whose name contains `query` (case-insensitive); all labels for an empty query. */
const filterLabelsByName = <T extends Pick<AssetLabel, 'name'>>(labels: T[], query: string) => {
    const normalized = normalizeTagName(query);
    return normalized ? labels.filter((label) => normalizeTagName(label.name).includes(normalized)) : labels;
};

export { filterLabelsByName, findLabelByName, normalizeTagName, sortLabelsAlphabetically };
